export const CONSENT_STORAGE_KEY = 'affinityai.cookie-consent.v1';
export const CONSENT_POLICY_VERSION = '1';
export const CONSENT_TTL_MS = 365 * 24 * 60 * 60 * 1000;
export const OPEN_CONSENT_EVENT = 'affinityai:open-cookie-settings';

export function readConsent(storage = globalThis.localStorage, now = Date.now()) {
  try {
    const parsed = JSON.parse(storage?.getItem(CONSENT_STORAGE_KEY) || 'null');
    if (
      !parsed ||
      parsed.policyVersion !== CONSENT_POLICY_VERSION ||
      !Number.isFinite(parsed.decidedAt) ||
      parsed.decidedAt + CONSENT_TTL_MS <= now
    ) {
      return null;
    }
    return {
      necessary: true,
      analytics: parsed.analytics === true,
      decidedAt: parsed.decidedAt,
      policyVersion: parsed.policyVersion,
    };
  } catch {
    return null;
  }
}

export function saveConsent({analytics = false} = {}, storage = globalThis.localStorage) {
  const decision = {
    necessary: true,
    analytics: analytics === true,
    decidedAt: Date.now(),
    policyVersion: CONSENT_POLICY_VERSION,
  };
  try {
    storage?.setItem(CONSENT_STORAGE_KEY, JSON.stringify(decision));
  } catch {
    // Consent UI remains usable even if browser storage is blocked.
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('affinityai:consent-changed', {detail: decision}));
  }
  return decision;
}

export function analyticsConsentGranted(storage = globalThis.localStorage) {
  return readConsent(storage)?.analytics === true;
}

export function openCookieSettings() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(OPEN_CONSENT_EVENT));
}
